"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerUISendOnScreenValidationFeedbackValidation = void 0;
class ChargerUISendOnScreenValidationFeedbackValidation {
    static isValid(entity) {
        // Validate entity.powernode_events_svc_OnScreenValidationFeedbackRequest_json for existence and correct type.
        if (entity.powernode_events_svc_OnScreenValidationFeedbackRequest_json ==
            undefined)
            return false;
        if (typeof entity.powernode_events_svc_OnScreenValidationFeedbackRequest_json !==
            "string")
            return false;
        return true;
    }
}
exports.ChargerUISendOnScreenValidationFeedbackValidation = ChargerUISendOnScreenValidationFeedbackValidation;
